/*
 * @Author: zhujian 
 * @Date: 2018-02-26 17:51:03 
 * @Last Modified by: zhujian
 * @Last Modified time: 2019-11-08 17:46:31
 */

import React from 'react';
import AxiosTS from '../../core/axios';
import { message, Modal, TimePicker } from 'antd';
import User from '../../core/user';
import moment from 'moment';
import { formatDate } from '../../core/function';
// import Bus from '@/core/bus';

class AddNewCardRecordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: this.props.type === 'NOT_CHECK' && this.props.item.beginDate < moment().valueOf() ? parseInt(this.props.item.beginDate) : moment().valueOf()
    };
  }

  handleSubmit = () => {
    AxiosTS.Business('public/attendance/attendanceManual', { adminId: User.aid(), studentId: this.props.item.studentId, attendanceDate: this.state.time }).then((res) => {
      if (this.props.type === 'NOT_CHECK') {
        message.success('补签到成功！');
      } else {
        message.success('补签退成功！')
      }
      this.props.close();
    })
  }

  render() {
    return (
      <Modal
        className="paly-card-modal"
        width={400}
        title={(this.props.type == 'NOT_CHECK' ? "签到" : '签退') + '补卡确认'}
        visible={true}
        okText="确定"
        onOk={this.handleSubmit}
        onCancel={this.props.close}>
        <p className='name'>将  <span>{this.props.item.studentName}</span> 的{this.props.type == 'NOT_CHECK' ? "签到" : '签退'}刷卡时间标记为</p>
        <div className='time'>
          <span className='date'>{formatDate('YYYY-MM-DD', moment().valueOf())}</span>
          <TimePicker
            allowClear={false}
            onChange={(e) => {
              if (e.valueOf() > moment().valueOf()) {
                message.warning('时间不能晚于当前时间')
                return
              }
              if (this.props.type == 2 && (e.valueOf() - this.props.item.checkInTime < 60000)) {
                message.warning('签退时间至少比签到时间晚一分钟！')
                return
              }
              this.setState({ time: e.valueOf() })
            }}
            value={moment(parseInt(this.state.time))} format='HH:mm' />
        </div>
      </Modal>
    )
  }
}

export default AddNewCardRecordModal;

